exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".title-head[data-v-4b968f98]{height:auto!important;line-height:30px}.info-box[data-v-4b968f98]{background-color:#f5fbfd;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;font-size:.8rem;font-weight:500}.info-box .fa-info-circle[data-v-4b968f98]{color:#01649d}.head[data-v-4b968f98]{color:#119bd2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-4b968f98","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/dsn/modalSaisieEffectifOeth/modalSaisieEffectifOeth.scss
// module id = FcFj
// module chunks = 2